import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/_alert';
import { Subject } from 'rxjs';
import * as countrycitystatejson from 'countrycitystatejson';
import { ZipCodeService } from 'src/app/_services/zip-code.service';

interface Country {
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.css']
})
export class CompanyDetailsComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private loginService: LoginService,
    private alertService: AlertService,
    private router: Router,
    private zipCodeService : ZipCodeService
  ) { }

  companyUser: any;
  submitted: boolean = true;
  bankUser: any;
  countries: Country[];
  states: any[];
  cities: string[];
  private countryData = countrycitystatejson;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  ngOnInit(): void {
    this.companyData();
  }

  // onStateClick(event) {
  //   var state = event.value;
  //   console.log("statee", state);
  //   if (state) {
  //     this.cities = this.getCitiesByState(this.companyDetailsForm.value.Country, state);
  //     console.log(this.cities)
  //     this.companyDetailsForm.get('City').enable();
  //   }
  // }

  companyDetailsForm: FormGroup = new FormGroup(
    {
      CompanyName: new FormControl('',[Validators.required]),
      CompanyRegistrationNumber: new FormControl(''),
      Address: new FormControl(''),
      District: new FormControl('US'),
      Country: new FormControl('US'),
      NatureOfBusiness: new FormControl(''),
      TaxIdNumber: new FormControl(''),
      City: new FormControl(''),
      State: new FormControl(''),
      ZipCode: new FormControl('', [
        Validators.maxLength(5),
        // Validators.maxLength(7)
      ]),
      Street: new FormControl('abcd'),
      CreatedBy: new FormControl(''),
      CustomerId: new FormControl(''),
      isActive: new FormControl(true),
    }
  )

  companyData() {
    const custId = this.authService.getRegistredUserDetails().customerId;
    const token = this.authService.getToken();
    this.loginService.allBankDetails(custId, token)
      .subscribe((response: any[]) => {
        this.bankUser = response;
        this.companyDetailsForm = new FormGroup(
          {
            CompanyRegistrationNumber: new FormControl(this.bankUser[this.bankUser.length - 1].companyRegistrationId?.toString()),
            TaxIdNumber: new FormControl(this.bankUser[this.bankUser.length - 1].companyTaxId),
            CreatedBy: new FormControl(this.bankUser[this.bankUser.length - 1].createdBy),
            CustomerId: new FormControl(this.bankUser[this.bankUser.length - 1].customerId),
            CompanyName: new FormControl('',[Validators.required]),
            Address: new FormControl(''  ),
            District: new FormControl('US'  ),
            Country: new FormControl('US'  ),
            NatureOfBusiness: new FormControl(''  ),
            // City: new FormControl({ value: null, disabled: true }  ),
            City: new FormControl(''),
            State: new FormControl(''  ),
            ZipCode: new FormControl('', [
              // Validators.minLength(5),
              Validators.maxLength(5)
            ]),
            Street: new FormControl('abcd'  ),
            isActive: new FormControl(true  ),
          })
      })
    // if (this.companyDetailsForm.value.Country) {
    //   this.states = this.getStatesByCountry(this.companyDetailsForm.value.Country);
    //   console.log(this.states)
    //   this.companyDetailsForm.get('State').enable();
    // }
  }


  onSubmit() {
    this.submitted = true;
    if (this.companyDetailsForm.valid) {
      const token = this.authService.getToken();
      this.loginService.createCompanyDetails(this.companyDetailsForm.value, token)
        .subscribe((response) => {
          console.log(response['data']);
          this.alertService.success('Success!! Company Details Saved SuccessFully.', this.options);
          setTimeout(() => {
            this.router.navigate(['/All/updateCompany']);
          }, 2000);
        }, (err) => {
          console.log(err);
          this.alertService.error(err.error.errors.Messages[0], this.options);
        })
      //this.alertService.success('Success!! Company Details Saved SuccessFully.', this.options);
    } else
      if ((!this.companyDetailsForm.value.CompanyRegistrationNumber || !this.companyDetailsForm.value.TaxIdNumber)) {
        this.alertService.error('Error :( Please fill the bank details first!', this.options);
      }
      else {
        console.log('please enter valid data');
        // this.alertService.error('Error :( Please Enter Valid Details!', this.options);
      }
  }

  get forms() {
    return this.companyDetailsForm.controls;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getCountries() {
    return this.countryData.getCountries();
  }

  getStatesByCountry(countryShotName: string) {
    return this.countryData.getStatesByShort(countryShotName);
  }

  getCitiesByState(country: any, state: any) {
    return this.countryData.getCities(country, state);
  }

  onZipCodeChange(event) {
    var zip = event.target.value;
    this.cities = [];
    this.states = [];
    if (zip == null || zip.length == 0 || zip.length < 5)
      return;
    this.zipCodeService.getDetailByZip(zip).subscribe((data: any) => {
      console.log(data);
      if (data == null) {
        return;
      }
      this.cities = data.places.map((place: any) => place['city']);
      this.states = data.places.map((place: any) =>  place['state']);

      // Auto-select first City and State
    const firstCity = this.cities[0];
    const firstState = this.states[0];

    if (firstCity) {
      this.companyDetailsForm.get('City')?.setValue(firstCity);
    }

    if (firstState) {
      this.companyDetailsForm.get('State')?.setValue(firstState);
    }
    });
  }

}
